export const PROFILE_REQUEST = 'PROFILE_REQUEST',
      SET_TOKEN = 'SET_TOKEN',
      SET_ORGANISATION_REQUEST = 'SET_ORGANISATION_REQUEST'
